import React, { FC } from "react";
import { Switch, Route } from "Utils/router";
import WithLocId from "HOC/WithLocId";
import { CampusMap } from "Containers/CampusMap";
import ADACampusMap from "Containers/ADACampusMap";
import TourInitializer from "HOC/TourInitializer";
import TourNavigator from "HOC/TourNavigator";
import YouVisitAnalytics from "HOC/YouVisitAnalytics";
import PageNotFound from "Components/helpers/PageNotFound";

interface Props {
  apolloData?: object;
  match?: {};
}

const Routes: FC<Props> = () => {
  return (
    <div>
      <Switch>
        <Route
          exact
          path="/tour/map/ada/:instId/:locId?"
          render={(props) => (
            <WithLocId
              instId={props.match.params.instId}
              locId={props.match.params.locId}
            >
              <TourInitializer>
                <TourNavigator>
                  <YouVisitAnalytics>
                    <ADACampusMap />
                  </YouVisitAnalytics>
                </TourNavigator>
              </TourInitializer>
            </WithLocId>
          )}
        />
        <Route
          exact
          path="/tour/map/:instId/:locId?"
          render={(props) => (
            <WithLocId
              instId={props.match.params.instId}
              locId={props.match.params.locId}
            >
              <TourInitializer>
                <TourNavigator>
                  <YouVisitAnalytics>
                    <CampusMap />
                  </YouVisitAnalytics>
                </TourNavigator>
              </TourInitializer>
            </WithLocId>
          )}
        />
        <Route>
          <PageNotFound />
        </Route>
      </Switch>
    </div>
  );
};

export default Routes;
